const { geolocation } = window.navigator

export const getCurrentPosition = params => new Promise((resolve, reject) => {
  geolocation.getCurrentPosition(
    position => resolve(position),
    error => reject(error),
    params,
  )
})
